import { useMemo } from 'react';
import { TagRes } from '@dealstack/shared/lib/generated';
import { useMantineTableWithPaginationFilteringSorting } from '@dealstack/frontend/shared/components/Table/MantineTable/useMantineTableWithPaginationFilteringSorting.ts';
import { getTagsTableColumns } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/Classifiers/components/TagsTab/getTagsTableColumns.tsx';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';

interface TagFilterDto {
	name?: string;
}

interface Props {
	onDelete: (tag: TagRes) => void;
	canEdit: boolean;
}

export const useTagsTableState = ({ onDelete, canEdit }: Props) => {
	const tMipManage = useTranslationMipManage();
	const columns = useMemo(
		() => getTagsTableColumns({ handlers: { onDelete }, canEdit, tMipManage }),
		[onDelete, canEdit, tMipManage]
	);

	const { mantineTableDataOperations } = useMantineTableWithPaginationFilteringSorting<
		TagRes,
		TagFilterDto
	>(columns, {}, false);

	return { columns, mantineTableDataOperations };
};
